import { render } from "./ProdutoEditarVariacao.vue?vue&type=template&id=adb2ab6a&scoped=true&ts=true"
import script from "./ProdutoEditarVariacao.vue?vue&type=script&lang=ts"
export * from "./ProdutoEditarVariacao.vue?vue&type=script&lang=ts"

import "./ProdutoEditarVariacao.vue?vue&type=style&index=0&id=adb2ab6a&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adb2ab6a"]])

export default __exports__